export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const USER_LOADED = "USER_LOADED";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const SET_ALERT = "SET_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";
export const EDIT_SUCCESS = "EDIT_SUCCESS";
export const EDIT_FAIL = "EDIT_FAIL";
export const PENDING_SUCCESS = "PENDING_SUCCESS";
export const PENDING_FAIL = "PENDING_FAIL";
export const APPROVE_FAIL = "APPROVE_FAIL";
export const REJECT_FAIL = "REJECT_FAIL";
export const QUIZ_LOAD_SUCCESS = "QUIZ_LOAD_SUCCESS";
export const QUIZ_LOAD_FAIL = "QUIZ_LOAD_FAIL";
export const QUIZ_UPDATE_FAIL = "QUIZ_UPDATE_FAIL";
export const STUD_LOAD_SUCCESS = "STUD_LOAD_SUCCESS";
export const STUD_LOAD_FAIL = "STUD_LOAD_FAIL";
export const COUN_LOAD_SUCCESS = "COUN_LOAD_SUCCESS";
export const COUN_LOAD_FAIL = "COUN_LOAD_FAIL";
export const REJECTED_SUCCESS = "REJECTED_SUCCESS";
export const REJECTED_FAIL = "REJECTED_FAIL";
export const QUIZ_SUBMIT_SUCCESS = "QUIZ_SUBMIT_SUCCESS";
export const QUIZ_SUBMIT_FAIL = "QUIZ_SUBMIT_FAIL";
export const COUN_FEED_SUCCESS = "COUN_FEED_SUCCESS";
export const COUN_FEED_FAIL = "COUN_FEED_FAIL";
export const STUD_FEED_SUCCESS = "STUD_FEED_SUCCESS";
export const STUD_FEED_FAIL = "STUD_FEED_FAIL";
export const FEED_FAIL = "FEED_FAIL";
export const MESSAGE_SEND_FAIL = "MESSAGE_SEND_FAIL";
export const MESSAGE_LOAD_SUCCESS = "MESSAGE_LOAD_SUCCESS";
export const MESSAGE_LOAD_FAIL = "MESSAGE_LOAD_FAIL";
export const APPROVED_SUCCESS = "APPROVED_SUCCESS";
export const APPROVED_FAIL = "APPROVED_FAIL";
export const FEED_DELETE_FAIL = "FEED_DELETE_FAIL";
export const VALID_SUCCESS = "VALID_SUCCESS";
export const VALID_FAIL = "VALID_FAIL";
